import React, { createContext, useContext, useEffect, useState } from 'react';

const EMPTY_BRANDING = {
  site_name: '',
  site_url: '',
  logo_url: '',
  phone: '',
  privacy_policy_url: '',
  telegram_bot_username: '',
  telegram_auth_enabled: false,
  max_auth_enabled: false,
};

const BrandingContext = createContext(EMPTY_BRANDING);

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(EMPTY_BRANDING);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await fetch('/api/infrastructure/branding/', { credentials: 'same-origin' });
        if (!response.ok) return;
        const data = await response.json();
        if (!cancelled) {
          setBranding({ ...EMPTY_BRANDING, ...data });
        }
      } catch {
        // Оформление не критично: кабинет должен работать и без него.
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (branding.site_name) {
      document.title = branding.site_name;
    }
    if (branding.logo_url) {
      const icon = document.querySelector('link[rel="icon"]');
      if (icon) icon.href = branding.logo_url;
    }
  }, [branding]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
